import script from "./ProposedProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProposedProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProposedProjectsPage.vue?vue&type=style&index=0&id=588d9440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588d9440"]])

export default __exports__